import { beautifyCamelCaseString } from 'src/app/common/stringUtils';
import { PolicyType } from '../api/governance/policy.model';
import { FilterTypesEnum } from '../filters/filterTypes.enum';
import { ISelectOption } from './selectOption.interface';

export const PolicyTypeSelectOptions: ISelectOption[] = [
  {
    id: `${FilterTypesEnum.PolicyType.toString()}-${PolicyType.default.toString()}`,
    value: `${PolicyType.default.toString()}`,
    displayName: beautifyCamelCaseString(PolicyType.default),
    filterType: FilterTypesEnum.PolicyType,
  },
  {
    id: `${FilterTypesEnum.PolicyType.toString()}-${PolicyType.development.toString()}`,
    value: `${PolicyType.development.toString()}`,
    displayName: beautifyCamelCaseString(PolicyType.development),
    filterType: FilterTypesEnum.PolicyType,
  },
  {
    id: `${FilterTypesEnum.PolicyType.toString()}-${PolicyType.production.toString()}`,
    value: `${PolicyType.production.toString()}`,
    displayName: beautifyCamelCaseString(PolicyType.production),
    filterType: FilterTypesEnum.PolicyType,
  },
  {
    id: `${FilterTypesEnum.PolicyType.toString()}-${PolicyType.test.toString()}`,
    value: `${PolicyType.test.toString()}`,
    displayName: beautifyCamelCaseString(PolicyType.test),
    filterType: FilterTypesEnum.PolicyType,
  },
];
